

function Home() {
    return (<div className="Page">
        <h1>Home page</h1>
    </div>);
}

export default Home;